export const isSetTrue = (value: "true" | "false") => value === "true";
